package com.sddamico.swigmore.models

/** League rules both the server and the browser need. Ballots close Friday at [DEADLINE_HOUR] Eastern. */
object PollRules {
  const val BALLOT_SIZE = 8
  /** The zone the app shows times in. */
  const val TIME_ZONE = "America/Los_Angeles"
  /** The deadline is set and stated in Eastern. */
  const val EASTERN_TIME_ZONE = "America/New_York"
  const val DEADLINE_HOUR = 23
  /**
   * A week's games show, not yet final, from the Sunday after kickoff at this hour Eastern, once the
   * Saturday games are in; the next poll opens for ballots then.
   */
  const val SCORES_RELEASE_HOUR = 9
  /** The first week with a poll: before week 7 not every team has played enough to rank. */
  const val FIRST_POLL_WEEK = 7
  /** Minutes before the deadline that owners who haven't voted are nudged, in order; the last is the last call. */
  val REMINDER_LEAD_MINUTES = listOf(14 * 60, 5 * 60, 30)

  /** Minutes after midnight Eastern on the deadline day that a reminder [leadMinutes] early goes out, for copy. */
  fun reminderMinuteOfDay(leadMinutes: Int) = DEADLINE_HOUR * 60 - leadMinutes
}

object AuthRules {
  const val OTP_LENGTH = 6
  const val OTP_EXPIRY_MINUTES = 10
  /** One code per email per this many seconds. */
  const val RESEND_COOLDOWN_SECONDS = 60
}

object RankingRules {
  /** Elo as the league's colley-rankings scripts run it. */
  const val ELO_START = 1500
  const val ELO_K = 32
  /** Daryl Morey's NFL exponent for Pythagorean win share. */
  const val PYTHAGOREAN_EXPONENT = 2.37
}
